/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import './WithdrawModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';

import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import toast from 'react-hot-toast';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  reasonsType: any;
  callBackGetData: (data: any) => void;
  selectedOffBoardingId: number;
  trans?: any;
}

const WithdrawModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  selectedOffBoardingId,
  trans,
}: ModalProps) => {
  const [remarks, setRemarks] = useState('');
  const [reason, setReason] = useState('');
  const [file, setFile] = useState('');
  const [filePath, setFilePath] = useState('');
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const fileUpload = (e: any) => {
    const _file: any = e.target.files[0];

    if (_file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      setFile(_file);
      setFilePath(image_as_base64);
    } else {
      setIsPDF(true);
      setFilePath('');
      setPDFName(_file?.name);
      setFile(_file);
    }
  };

  const handleSubmit = () => {
    if (reason == '') {
      toast.error(trans('Please fill the missing fields'));
    } else {
      callBackGetData({
        id: selectedOffBoardingId,
        reason: reason,
        remarks: remarks,
        attachment: file,
      });
      closeModal();
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="600px"
      modalWidth="500px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Withdraw Off-Boarding') }}
        closeModal={closeModal}
      />

      <Grid
        container
        spacing={3}
        style={{
          marginTop: '5px',
        }}
      >
        <Grid item xs={6}>
          <CustomTextField
            type="string"
            label={trans('Reason')}
            placeholder={trans('Write Reason')}
            value={reason}
            onChange={(e: any) => setReason(e.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <CustomTextField
            type="string"
            label={trans('Remarks')}
            placeholder={trans('Write Remarks')}
            value={remarks}
            onChange={(e: any) => setRemarks(e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <DropAndSelect
            upload={fileUpload}
            src={filePath}
            isPDF={isPDF}
            pdfName={pdfName}
            onDelete={() => {
              setFilePath('');
              setPDFName('');
              setIsPDF(false);
            }}
          />
        </Grid>
      </Grid>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default WithdrawModalPresenter;
